/**
* Science City Map JS
* -----------------------------------------------------------------------------
*
* All the JS for the Science City Map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import lottie from 'lottie-web';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'science-city-map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
      // gsap.registerPlugin( ScrollTrigger );
      const lowerAnimation = lottie.loadAnimation( {
        container: $( '.science-city-map .map-container-ll' )[0],
        renderer: 'svg',
        name: 'science-city-map-ll',
        loop: false,
        // autoplay: false,
        path: $( '.science-city-map .map-container-ll' ).attr( 'data-url' ),
      } );

      const upperAnimation = lottie.loadAnimation( {
        container: $( '.science-city-map .map-container-ul' )[0],
        renderer: 'svg',
        name: 'science-city-map-ul',
        loop: false,
        // autoplay: false,
        path: $( '.science-city-map .map-container-ul' ).attr( 'data-url' ),
      } );

      let animation = lowerAnimation;

      // Once animation is loaded, move to the last frame
      upperAnimation.addEventListener( 'DOMLoaded', function() {
        upperAnimation.goToAndStop( upperAnimation.totalFrames - 1, true );
      } );
      lowerAnimation.addEventListener( 'DOMLoaded', function() {
        lowerAnimation.goToAndStop( lowerAnimation.totalFrames - 1, true );
      } );

      let prevSpace;
      $( '.space-selection' ).click( function() {
        loadAnimation( this );
      } );

      function loadAnimation( ID ) {
        let element;
        let prevElement;

        if ( typeof ID === 'object' ) {
          element = $( ID ).attr( 'data-id' );
        } else {
          element = ID;
        }

        if ( typeof prevSpace === 'object' ) {
          prevElement = $( ID ).attr( 'data-id' );
        } else {
          prevElement = prevSpace;
        }

        const newStart = parseInt( $( '.science-city-map .animation-frames .anim-frames[data-id="' + element + '"]' ).attr( 'data-start' ) );
        const newEnd = parseInt( $( '.science-city-map .animation-frames .anim-frames[data-id="' + element + '"]' ).attr( 'data-end' ) );
        const oldStart = parseInt( $( '.science-city-map .animation-frames .anim-frames[data-id="' + prevElement + '"]' ).attr( 'data-start' ) );
        const oldEnd = parseInt( $( '.science-city-map .animation-frames .anim-frames[data-id="' + prevElement + '"]' ).attr( 'data-end' ) );

        if ( prevSpace ) {
          if ( reduceMotion ) {
            animation.goToAndStop( oldStart, true );
            animation.goToAndStop( newEnd, true );
          } else {
            animation.playSegments( [oldEnd, oldStart], true );
            animation.playSegments( [newStart, newEnd], true );
          }
        } else {
          if ( reduceMotion ) {
            animation.goToAndStop( newEnd, true );
          } else {
            animation.playSegments( [newStart, newEnd], true );
          }
        }

        prevSpace = element;
      }

      let isUpper = false;

      $( '.science-city-map .toggler button:not([data-toggle-class="is-lower"])' ).on( 'click', ( event ) => {
        if ( !isUpper ) {
          isUpper = true;
          animation = upperAnimation;
        }
      } );

      $( '.science-city-map .toggler button:not([data-toggle-class="is-upper"])' ).on( 'click', ( event ) => {
        if ( isUpper ) {
          isUpper = false;
          animation = lowerAnimation;
        }
      } );

      $( '.space-selection' ).on( 'toggleAfter', function( event ) {
        if ( window.easyToggleState.isActive( event.target ) ) {
          $( event.target ).attr( 'tabindex', 0 );
        } else {
          $( event.target ).attr( 'tabindex', -1 );
        }
      } );
      $( '.science-city-map .mobile-cards--ll' ).each( function( index, slide ) {
        const splide = new Splide( slide, {
          type: 'slide',
          perPage: 2,
          perMove: 1,
          gap: '1rem',
          pagination: false,
          drag: false,
          live: true,
          breakpoints: {
            600: {
              perPage: 1,
            },
          },
        } );

        splide.mount();

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
          };
        } );

        $( 'button[data-toggle-class="is-lower"]' ).on( 'click', function() {
          splide.refresh();
        } );
      } );

      $( '.science-city-map .mobile-cards--ul' ).each( function( index, slide ) {
        const splide = new Splide( slide, {
          type: 'slide',
          perPage: 2,
          perMove: 1,
          gap: '1rem',
          pagination: false,
          drag: false,
          live: true,
          breakpoints: {
            600: {
              perPage: 1,
            },
          },
        } );

        splide.mount();

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
          };
        } );

        $( 'button[data-toggle-class="is-upper"]' ).on( 'click', function() {
          splide.refresh();
        } );
      } );

      $( document ).on( 'mouseenter', '.science-city-map svg > g > g', function() {
        const loc = ( '00' + $( this ).index() ).slice( -2 );
        if ( $( this ).index() > 0 ) {
          if ( isUpper ) {
            if ( $( 'button[data-toggle-target="#scm-UL' + loc + '"]' ).length ) {
              $( 'button[data-toggle-target="#scm-UL' + loc + '"]' ).trigger( 'click' );
            } else {
              $( '.animation-frames .closer[data-toggle-radio-group="science-city-map-ul"]' ).trigger( 'click' );
              loadAnimation( 'UL' + loc );
            }
          } else {
            if ( $( 'button[data-toggle-target="#scm-LL' + loc + '"]' ).length ) {
              $( 'button[data-toggle-target="#scm-LL' + loc + '"]' ).trigger( 'click' );
            } else {
              $( '.animation-frames .closer[data-toggle-radio-group="science-city-map-ll"]' ).trigger( 'click' );
              loadAnimation( 'LL' + loc );
            }
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'science-city-map', COMPONENT );
} )( app );
